"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _highchartsMore = _interopRequireDefault(require("highcharts/highcharts-more"));
var _exporting = _interopRequireDefault(require("highcharts/modules/exporting"));
var _exportData = _interopRequireDefault(require("highcharts/modules/export-data"));
var _heatmap = _interopRequireDefault(require("highcharts/modules/heatmap"));
var _boost = _interopRequireDefault(require("highcharts/modules/boost"));
var _boostCanvas = _interopRequireDefault(require("highcharts/modules/boost-canvas"));
var _Preferences = _interopRequireDefault(require("chaire-lib-common/lib/config/Preferences"));
var _optionsGenerator = require("./optionsGenerator");
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _chartDefaultStyle = _interopRequireDefault(require("./chartDefaultStyle"));
const _excluded = ["error"];
(0, _highchartsMore.default)(_highcharts.default);
(0, _exporting.default)(_highcharts.default);
(0, _exportData.default)(_highcharts.default);
(0, _heatmap.default)(_highcharts.default);
(0, _boost.default)(_highcharts.default);
(0, _boostCanvas.default)(_highcharts.default);
(0, _chartDefaultStyle.default)(_highcharts.default);
class Chart extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isEmpty: false,
      isError: false,
      options: {}
    };
  }
  componentDidMount() {
    const asyncOptions = (0, _optionsGenerator.generateGraphOptions)(this.props);
    asyncOptions.then(_ref => {
      let {
          error
        } = _ref,
        options = (0, _objectWithoutProperties2.default)(_ref, _excluded);
      if (Object.keys(options).length === 0) {
        this.setState({
          isLoaded: true,
          isEmpty: true,
          isError: error,
          options: {}
        });
      } else {
        this.setState({
          isLoaded: true,
          isEmpty: false,
          options: options,
          isError: error
        });
      }
    });
  }
  render() {
    const {
      size,
      id,
      t
    } = this.props;
    const {
      isLoaded,
      isEmpty,
      options,
      isError
    } = this.state;
    if (isEmpty || isError || Object.keys(options).length === 0) {
      return /*#__PURE__*/_react.default.createElement("h3", {
        style: {
          margin: 'auto'
        }
      }, isError ? t('osc2ar:chartDataError') : t('osc2ar:noData'));
    }
    if (!isLoaded) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, {
        message: t('osc2ar:GraphLoading')
      });
    }
    if (size == "small") {
      if (options.title.style) {
        options.title.style["fontSize"] = "16px";
      }
      if (options.legend) {
        options.legend["enabled"] = false;
      }
      options.credits = "";
    }
    process.env.APP_NAME == 'octavi' ? _highcharts.default.setOptions({
      lang: _Preferences.default.get('highcharts.lang.' + this.props.i18n.language)
    }) : "";
    return /*#__PURE__*/_react.default.createElement(_highchartsReactOfficial.default, {
      options: options,
      highcharts: _highcharts.default,
      containerProps: {
        style: {
          height: "100%",
          width: "100%"
        }
      },
      key: id
    });
  }
}
exports.default = Chart;
Chart.propTypes = {
  t: _propTypes.default.func,
  size: _propTypes.default.string,
  id: _propTypes.default.string
};